import { render, staticRenderFns } from "./line-pricing-editor-page.vue?vue&type=template&id=ebc3e8bc&scoped=true"
import script from "./line-pricing-editor-page.vue?vue&type=script&lang=js"
export * from "./line-pricing-editor-page.vue?vue&type=script&lang=js"
import style0 from "./line-pricing-editor-page.vue?vue&type=style&index=0&id=ebc3e8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc3e8bc",
  null
  
)

export default component.exports